import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class PrincipalRoleDTO extends DataTransferObject {

    public PDO_ID: number;

    public ParentPDO_ID: number;

    public Name: string;

    public FullName: string;

    public CanSet: boolean;

    constructor() {
        super({ xmlProperties: ['PDO_ID', 'ParentPDO_ID', 'Name', 'FullName', 'CanSet'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.PDO_ID = this.defaultFromType('long');
        this.ParentPDO_ID = this.defaultFromType('long');
        this.Name = this.defaultFromType('string');
        this.FullName = this.defaultFromType('string');
        this.CanSet = this.defaultFromType('bool');
    }
}

ComponentManager.setModel('PrincipalRoleDTO', PrincipalRoleDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');